module.exports = __webpack_public_path__ + "static/frog3-23dbab32421330bb9e69682807e95fe8.png";